import React from 'react';

const RekapitulasiPegawai = React.lazy(() => import('./RekapitulasiPegawai'))
const LaporanJabfung = React.lazy(() => import('./LaporanJabfung'))
const Grafik = React.lazy(() => import('./Grafik'))
const Laporan = React.lazy(() => import('./Laporan'))
const LaporanJumlahJabatanUnit = React.lazy(() => import('./LaporanJumlahJabatanUnit'))
const PreviewRekapitulasi = React.lazy(() => import('./RekapitulasiPegawai/PreviewRekapitulasi'))
const RekapitulasiPenghargaanASN = React.lazy(() => import('./RekapitulasiPenghargaanASN'))

export const laporanUmumConfigs = [
  {
    path: '/laporan-umum/rekapitulasi',
    element: <RekapitulasiPegawai />,
  },
  {
    path: '/laporan-umum/rekapitulasi/preview/:jenis/:unker',
    element: <PreviewRekapitulasi />,
  },
  {
    path: '/laporan-umum/rekapitulasi-penghargaan-asn',
    element: <RekapitulasiPenghargaanASN />,
  },
  {
    path: '/laporan-umum/laporan',
    element: <Laporan />,
    permittedRole: ['Pegawai', 'Administrator', 'Viewer', 'Operator', 'Operator Eselon 1']
  },
  {
    path: '/laporan-umum/laporan/nominatif',
    element: <Laporan />,
    permittedRole: ['Pegawai', 'Administrator', 'Viewer', 'Operator', 'Operator Eselon 1']
  },
  {
    path: '/laporan-umum/laporan/urut-kepangkatan',
    element: <Laporan />,
    permittedRole: ['Pegawai', 'Administrator', 'Viewer', 'Operator', 'Operator Eselon 1']
  },
  {
    path: '/laporan-umum/laporan/naik-pangkat',
    element: <Laporan />,
    permittedRole: ['Pegawai', 'Administrator', 'Viewer', 'Operator', 'Operator Eselon 1']
  },
  {
    path: '/laporan-umum/laporan/naik-gaji-berkala',
    element: <Laporan />,
    permittedRole: ['Pegawai', 'Administrator', 'Viewer', 'Operator', 'Operator Eselon 1']
  },
  {
    path: '/laporan-umum/laporan/diklat-perjenjangan',
    element: <Laporan />,
    permittedRole: ['Pegawai', 'Administrator', 'Viewer', 'Operator', 'Operator Eselon 1']
  },
  {
    path: '/laporan-umum/laporan/sumpah-pegawai',
    element: <Laporan />,
    permittedRole: ['Pegawai', 'Administrator', 'Viewer', 'Operator', 'Operator Eselon 1']
  },
  {
    path: '/laporan-umum/laporan/prajabatan',
    element: <Laporan />,
    permittedRole: ['Pegawai', 'Administrator', 'Viewer', 'Operator', 'Operator Eselon 1']
  },
  {
    path: '/laporan-umum/laporan/slks',
    element: <Laporan />,
    permittedRole: ['Pegawai', 'Administrator', 'Viewer', 'Operator', 'Operator Eselon 1']
  },
  {
    path: '/laporan-umum/laporan/pendidikan-jurusan',
    element: <Laporan />,
    permittedRole: ['Pegawai', 'Administrator', 'Viewer', 'Operator', 'Operator Eselon 1']
  },
  {
    path: '/laporan-umum/jabfung',
    element: <LaporanJabfung />,
    permittedRole: ['Pegawai', 'Administrator', 'Viewer', 'Operator', 'Operator Eselon 1']
  },
  {
    path: '/laporan-umum/jabfung/pejabat-fungsional',
    element: <LaporanJabfung />,
    permittedRole: ['Pegawai', 'Administrator', 'Viewer', 'Operator', 'Operator Eselon 1']
  },
  {
    path: '/laporan-umum/jabfung/rekab-jen-fungsional-unker',
    element: <LaporanJabfung />,
    permittedRole: ['Pegawai', 'Administrator', 'Viewer', 'Operator', 'Operator Eselon 1']
  },
  {
    path: '/laporan-umum/jabfung/rekab-pegawai-fungsional',
    element: <LaporanJabfung />,
    permittedRole: ['Pegawai', 'Administrator', 'Viewer', 'Operator', 'Operator Eselon 1']
  },
  {
    path: '/laporan-umum/grafik',
    element: <Grafik />,
    permittedRole: ['Pegawai', 'Administrator', 'Viewer', 'Operator', 'Operator Eselon 1']
  },
  {
    path: '/laporan-umum/grafik/golongan',
    element: <Grafik />,
    permittedRole: ['Pegawai', 'Administrator', 'Viewer', 'Operator', 'Operator Eselon 1']
  },
  {
    path: '/laporan-umum/grafik/tingkat-pendidikan',
    element: <Grafik />,
    permittedRole: ['Pegawai', 'Administrator', 'Viewer', 'Operator', 'Operator Eselon 1']
  },
  {
    path: '/laporan-umum/grafik/status-pegawai',
    element: <Grafik />,
    permittedRole: ['Pegawai', 'Administrator', 'Viewer', 'Operator', 'Operator Eselon 1']
  },
  {
    path: '/laporan-umum/grafik/usia',
    element: <Grafik />,
    permittedRole: ['Pegawai', 'Administrator', 'Viewer', 'Operator', 'Operator Eselon 1']
  },
  {
    path: '/laporan-jumlah-jabatan-unit',
    element: <LaporanJumlahJabatanUnit />,
    permittedRole: ['Pegawai', 'Administrator', 'Operator', 'Viewer', 'Operator Eselon 1']
  },
];
